import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalComponent } from '../../global-component';

/**
 * Service responsible for handling automation-related operations.
 */
@Injectable({
  providedIn: 'root'
})
export class AutomationsService {

  /**
   * Creates a new instance of AutomationsService.
   * @param http Angular HttpClient instance used for making HTTP requests.
   */
  constructor(private http: HttpClient) {}

  /**
   * Creates a new automation.
   * @param postData Data to be sent when creating a new automation.
   * @returns Observable that emits the response from the server upon successful creation.
   */
  createAutomation(postData: any): Observable<any> {
    return this.http.post(
      GlobalComponent.BASE_API_URL + "automations",
      { data: postData }
    );
  }

  getAutomations(postdata : any): Observable<any> {
    return this.http.get(
      GlobalComponent.BASE_API_URL + `automations?filters[activestate][$eq]=true&filters[vendorguid][$eq]=${postdata.vendorguid}`
    );
  }
  
  /**
   * Deletes an existing automation by ID.
   * @param automationId The ID of the automation to delete.
   * @returns Observable that emits the response from the server upon successful deletion.
   */
  deleteAutomation(automationId: number): Observable<any> {
    return this.http.delete(
      GlobalComponent.BASE_API_URL + `automations/${automationId}`
    );
  }

  /**
     * Updates an existing automation.
     * @param id - The ID of the automation to be updated.
     * @param postData - The data to be sent when updating the automation.
     * @returns Observable that emits the response from the server upon successful update.
     */
  updateAutomation(automationId: number, postData: any): Observable<any> {
    return this.http.put(
      GlobalComponent.BASE_API_URL + `automations/${automationId}`,
      { data: postData }
    );
}
  
  



}